import React from "react"
import {connect} from "react-redux"
import {Field, reduxForm, getFormValues, SubmissionError} from "redux-form"
import {
    SelectMenu,
    CheckBoxInput,
    EmailInput,
    PasswordInput,
    TextInput,
    SubmitButton
} from '../components/forms'
import {UserProfile} from "../api/user-profile";
import {Errors} from "../api/util";
import Validators from "../validation"

const AccountOptions = [

    {label: "No I don't think we do", value: false, index: 0},
    {label: "Yes we have an account", value: true, index: 1},
];


let PasswordIndicators = (props) => {
    return (
        <div className="password-indicators">
            <div className={(Validators.Registration.PasswordLengthValidation(props.password)) ? "minlength valid" : "minlength"}>At least 12 characters
            </div>
            <div
                className={(Validators.Registration.PasswordAlphaNumericValidation(props.password)) ? "numbers valid" : "numbers"}>2
                numbers
            </div>
            <div className={(Validators.Registration.PasswordSymbolValidation(props.password)) ? "symbol valid" : "symbol"}>1 special character (e.g. @, *, #)
            </div>
        </div>
    )
};

PasswordIndicators = connect(state => {
    return {
        password: getFormValues('registration')(state).password || ""
    }
})(PasswordIndicators);


let RegistrationFormComponent = props => {


    return (
        <div className={props.submitFailed ? "registration-form show-errors" : "registration-form "}>
            <form onSubmit={props.handleSubmit} className="row widget-form registration-step1-form">
                <Field name="firstname" title="First name" id="firstname" placeholder="" component={TextInput} />
                <Field name="lastname" title="Last name" id="lastname" placeholder="" component={TextInput} autocomplete="family-name"/>
                <Field name="email" title="Work email address" id="email" placeholder="someone@somewhere.com" component={EmailInput} autocomplete={"email"}/>
                <Field name="phone" title="Contact number" id="phone" placeholder="" component={TextInput} autocomplete={"tel"}/>
                <Field name="username" title="Username" id="username" placeholder="" component={TextInput} autocomplete={"username"}/>
                <Field name="password" title="Password" id="password" placeholder="" component={PasswordInput} autocomplete={"password"}/>
                <PasswordIndicators/>
                <Field name="passwordconfirmation" title="Retype password" id="passwordconfirmation" placeholder="" component={PasswordInput}/>
                <Field name="hasaccount" options={AccountOptions} title="Does your company have an account with us?" id="hasaccount" component={SelectMenu}/>
                <div className="fine-print">
                    <h3>The fine print</h3>
                    <p>It’s pretty simple. You just need to agree to the terms and conditions below.</p>
                    <p>*The <a href={props.config.terms.url} target="_blank">Terms and Conditions</a> and <a
                        href={props.config.policy.url} target="_blank">Privacy Policy</a> to continue with your
                        registration.</p>
                </div>
                <Field name="agreed" title="I agree with the above" id="agreed" component={CheckBoxInput}
                       type="checkbox"/>
                <SubmitButton id={"registration-button-1"} label={"SUBMIT & CONTINUE"}/>
            </form>

        </div>
    )

};

RegistrationFormComponent = connect(
    state => {
        return {
            config: getFormValues('config')(state),
            registration: getFormValues('registration')(state),
        }
    }
)(reduxForm({
    form: 'registration',
    asyncValidate: (values, dispatch, props, blurredField) => {

        return new Promise((resolve, reject) => {

            if (blurredField === 'username') {
//                if(values['username'].match(/\s/)){
//                    reject({"username": {"message": "Username must not contain spaces"}})
//                }
//                else{
                    return UserProfile(props.config.userprof).user(values.username).Exists()
                        .then(
                            () => {
                                reject ( {"username": {"message": "Username already taken"}} )
                            },
                            (reason) => {
                                if (reason.status >= 500 || reason.status === 0) {
                                    reject( {"username": {"message": "Not validated"}});
                                    dispatch(Errors.create(null, null, props, "RegistrationFormContainer#asyncValidate", "Backend technical issue.", []));
                                }
                            }
                        )

                }
            //}
            else {
                resolve({});
            }
        });
    },
    asyncBlurFields: ['firstname', 'lastname', 'email', 'phone', 'username', 'password', 'passwordconfirmation']
})(RegistrationFormComponent));

class RegistrationFormContainer extends React.Component {


    render = () => {
        return (
            <RegistrationFormComponent
                path={this.props.path}
                userprofile={this.userprofile}
                onSubmitSuccess={this.props.handleSubmitSuccess}
                onSubmitFail={this.props.handleSubmitFail}
                validate={this.props.validate}
                onSubmit={this.props.handleSubmit}
                destroyOnUnmount={this.props.destroyOnUmount}
            />

        )
    }

}


RegistrationFormContainer = connect(
    state => {
        return {
            config: getFormValues('config')(state),
            registration: getFormValues('registration')(state),
        }
    }
)(RegistrationFormContainer);

RegistrationFormContainer.defaultProps = {
    handleSubmit: (values, dispatch, props) => {
        const e = Errors.clear();
        dispatch(e);
        return UserProfile(props.config.userprof).user(props.registration.username).Exists()
            .then(
                () => {
                    throw new SubmissionError({"username": {"message": "Username already taken"}})
                },
                (reason) => {
                    if (reason.status === 0 || reason.status >= 500) {
                        dispatch(Errors.TechnicalError());
                        throw new SubmissionError({"username": {"message": "Username has not been validated"}});
                    } else {
                        if (reason.status !== 404) {
                            throw new SubmissionError({_error: reason})
                        }
                    }
                }
            )
    },
    handleSubmitFail: (errors, dispatch, submitErrors, props) => {
        if ((submitErrors && submitErrors.errors) || errors) {
            if (submitErrors && submitErrors.errors && (submitErrors.errors.status === 0 || submitErrors.errors.status >= 500)) {
                dispatch(Errors.TechnicalError());
            }
            else if (submitErrors && submitErrors.errors && (submitErrors.errors.status === 404)) {
                dispatch(Errors.InvalidFormSubmission());
            }
            else if (errors || (submitErrors && submitErrors.errors)) {
                dispatch(Errors.InvalidFormSubmission())
            }
        }
    },
    handleSubmitSuccess: (result, dispatch, props) => {
    },
    validate: (values) => {
        return Validators.Registration.validate(values);
    }
    ,
    destroyOnUmount: false,
};

export {
    RegistrationFormContainer,
    AccountOptions,
    RegistrationFormComponent
}
